import {
  IonBackButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonIcon,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { logoReact, logoIonic, flash, construct } from 'ionicons/icons';
import { buildMigrationJourneyCoverageSummary, formatCoverageStatus } from '@/services/util/migrationCoverageSummary';
import { migrationJourneyCoverageAreas } from './migrationJourneyCoverage';
import './About.css';

const About: React.FC = () => {
  const coverageSummary = buildMigrationJourneyCoverageSummary(migrationJourneyCoverageAreas);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/home" />
          </IonButtons>
          <IonTitle>About</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div className="about-container">
          <h1>Technology Stack</h1>
          
          <IonList>
            <IonItem>
              <IonIcon icon={logoReact} slot="start" color="primary" />
              <IonLabel>
                <h2>React 19</h2>
                <p>Modern UI library with hooks and functional components</p>
              </IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={logoIonic} slot="start" color="primary" />
              <IonLabel>
                <h2>Ionic Framework</h2>
                <p>Cross-platform UI components for web and mobile</p>
              </IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={flash} slot="start" color="primary" />
              <IonLabel>
                <h2>Vite</h2>
                <p>Lightning-fast build tool with HMR support</p>
              </IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={construct} slot="start" color="primary" />
              <IonLabel>
                <h2>Capacitor</h2>
                <p>Native runtime for building iOS and Android apps</p>
              </IonLabel>
            </IonItem>
          </IonList>

          <div className="feature-section">
            <h2>Features</h2>
            <ul>
              <li>✨ Hot Module Replacement (HMR) for rapid development</li>
              <li>📱 Native mobile app capabilities via Capacitor</li>
              <li>🎨 Ionic design system with adaptive styling</li>
              <li>🔄 Live reload for simulator testing</li>
              <li>📦 TypeScript for type safety</li>
              <li>🚀 Optimized production builds</li>
            </ul>
          </div>

          <div className="feature-section">
            <h2>Migration Journey Coverage</h2>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px', marginBottom: '20px' }}>
              <IonCard style={{ margin: 0 }}>
                <IonCardHeader>
                  <IonCardTitle>{coverageSummary.totalJourneys}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>Journeys tracked</IonCardContent>
              </IonCard>

              <IonCard style={{ margin: 0 }}>
                <IonCardHeader>
                  <IonCardTitle>{coverageSummary.automatedJourneys}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>Automated journeys</IonCardContent>
              </IonCard>

              <IonCard style={{ margin: 0 }}>
                <IonCardHeader>
                  <IonCardTitle>{coverageSummary.pendingJourneys}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>Journeys pending automation</IonCardContent>
              </IonCard>

              <IonCard style={{ margin: 0 }}>
                <IonCardHeader>
                  <IonCardTitle>{coverageSummary.automatedPercentage}%</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>Automated coverage</IonCardContent>
              </IonCard>
            </div>

            <p style={{ margin: '0 0 16px 0', lineHeight: 1.6 }}>
              Coverage is tracked against the migration scenario matrix and should be updated as unit, component, and end-to-end journeys are added.
            </p>

            <IonList>
              {migrationJourneyCoverageAreas.map((area) => (
                <IonItem key={area.id}>
                  <IonLabel>
                    <h3>{area.title}</h3>
                    <p>
                      {area.automatedJourneys} of {area.totalJourneys} automated, primary layer {area.primaryLayer}, status {formatCoverageStatus(area.status)}.
                    </p>
                    <p>Next focus: {area.nextFocus}</p>
                  </IonLabel>
                </IonItem>
              ))}
            </IonList>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default About;
